import { render } from "./Explanation.vue?vue&type=template&id=5dd0eeae&scoped=true"
import script from "./Explanation.vue?vue&type=script&lang=js"
export * from "./Explanation.vue?vue&type=script&lang=js"

import "./Explanation.vue?vue&type=style&index=0&id=5dd0eeae&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd0eeae"]])

export default __exports__